export const GET_PRICE_PREVIEW_REQUEST = 'GET_PRICE_PREVIEW_REQUEST';
export const GET_PRICE_PREVIEW_SUCCESS = 'GET_PRICE_PREVIEW_SUCCESS';
export const GET_PRICE_PREVIEW_FAILURE = 'GET_PRICE_PREVIEW_FAILURE';
export const RESET_PRICE_PREVIEW = 'RESET_PRICE_PREVIEW';
